module.exports = __webpack_public_path__ + "static/media/kebab_menu.df78f23b.svg";